import { useEffect } from 'react';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import bgSub from 'src/assets/images/bg_sub.jpg';
import CheckBox from 'src/components/common/CheckBox';
import { RequestIdState } from 'src/recoil/common';
import { TelecomTypeState } from 'src/recoil/join';
import {
  AllCheckState,
  PartnerState,
  RecoilUiList,
  TermsAgreeState
} from 'src/recoil/ui';
import { JoinTermsDetail } from 'src/types/type';
import styled from 'styled-components';
import { monitoredOpen } from 'src/utils/sentry/navigation';

const TermsWrap = styled.div`
  border-top: solid 2px #e0e0e0;
  border-bottom: solid 2px #e0e0e0;
  padding: 10px;
  margin: 10px 0;
  box-sizing: border-box;
  background-color: #fff;
`;

const TermsTop = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  height: 28px;
  font-size: 14px;
  line-height: 28px;
  margin-bottom: 15px;
`;

const TermsItemWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-top: 10px;
  color: gray;
  font-size: 12px;
`;

export const ModalTermsWrap = styled.div`
  overflow-y: scroll;
  height: 100%;
`;

export const ModalTermsTop = styled.div`
  height: 50px;
  background: url('${bgSub}') no-repeat center center;
  background-size: cover;
`;

export const ModalTermsContainer = styled.div`
  padding: 15px;
`;

export const ModalTermsTitle = styled.h2`
  text-align: center;
  font-size: 16px;
`;

export const TermsContents = styled.pre`
  margin-top: 10px;
  font-size: 12px;
  white-space: pre-line;
`;


const Terms = () => {
  const [isAllCheck, setAllCheck] = useRecoilState(AllCheckState);
  const [termsAgree, setTermsCheck] = useRecoilState(TermsAgreeState);
  const { UiData: { layoutsTerms: { shape }} } = useRecoilValue(PartnerState)
  const telecomType = useRecoilValue(TelecomTypeState);
  const requestId = useRecoilValue(RequestIdState);
  const { termsData, isAgreeAllRequiredTerms } = useRecoilValue(RecoilUiList);
  const resetTermsCheck = useResetRecoilState(TermsAgreeState)

  const AllTerms = (): void => {
    // 전체동의
    const copyArray = [...termsAgree]
    if (!isAllCheck) {
      // 전체동의시 필수선택 체크
      termsData?.Terms.forEach((value: JoinTermsDetail) => {
        if (value.Order !== undefined && value.Required) {
          copyArray[value.Order - 1] = 1
        }
      })
    } else {
      copyArray.fill(0)
    }
    setTermsCheck(copyArray)
    setAllCheck(!isAllCheck)
  }
  const EachTerms = (order: number): void => {
    // 개별동의
    const copyArray = [...termsAgree]
    copyArray[order - 1] = termsAgree[order - 1] === 1 ? 0 : 1
    setTermsCheck(copyArray)
  }

  const handleTermsClick = (order: number) => {
    const width: number = 400
    const height: number = 600
    const url: string | undefined = requestId
      ? `/terms/${requestId}/${telecomType}/${termsData.TermsIdx}/${order}`
      : undefined

    if (url) {
      monitoredOpen(url, 'terms-popup', '_blank', { windowFeatures: `width=${width}, height=${height}` })
    }
  };

  useEffect(() => {
    resetTermsCheck()
    setAllCheck(false)
  }, [telecomType, resetTermsCheck, setAllCheck]);

  useEffect(() => {
    setAllCheck(isAgreeAllRequiredTerms)
  }, [isAgreeAllRequiredTerms, setAllCheck])

  return (
    <>
      <TermsWrap>
        <TermsTop>
          <CheckBox
            label="서비스 필수 항목 모두 동의"
            type="circle"
            checked={isAllCheck}
            onChange={AllTerms}
          />
        </TermsTop>
        <TermsItemWrap>
          {termsData?.Terms.map(
            (terms: JoinTermsDetail, index: number) =>
              terms.Order !== undefined && (
                <CheckBox
                  type={shape}
                  key={index}
                  id={index}
                  label={terms.Title}
                  onChange={()=> EachTerms(terms.Order!)}
                  checked={termsAgree[terms.Order - 1] === 1}
                  onClick={() => handleTermsClick(terms.Order!)}
                />
              ),
          )}
        </TermsItemWrap>
      </TermsWrap>
    </>
  );
};

export default Terms;
